import { MakerCheckerState } from "./types";

const state: MakerCheckerState = {
  pendingChanges: [],
  completedChanges: [],
  userAuthentication: {},
  mainType: "",
  currentDepartment: "",
  activeLeftPane: "pending",
};

export default state;
